import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

export * from './animations';

@NgModule({
  imports: [CommonModule],
})
export class AnimationsModule {}
